import React, { ReactElement } from 'react';

export function PlayIcon(): ReactElement {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <circle cx='12' cy='12' r='10'></circle>
      <polygon points='10 8 16 12 10 16 10 8'></polygon>
    </svg>
  );
}
